<template>
  <div />
</template>

<script setup lang="ts">
import { onBeforeUnmount } from 'vue'

const emit = defineEmits<{
  (e: 'keyup', event: KeyboardEvent): void
}>()

const handler = (event: KeyboardEvent): void => {
  emit('keyup', event)
}
window.addEventListener('keyup', handler)

onBeforeUnmount(() => {
  window.removeEventListener('keyup', handler)
})
</script>

<style scoped>
div {
  display: none;
}
</style>
